import { StyledIconTrash } from './IconTrash.styled';

const IconTrash = () => {
  return <StyledIconTrash />;
};

export default IconTrash;
